import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommerceGeneralSettingsEntityState} from "../reducers/ecommerce-general-settings.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommerceGeneralSettingsState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommerceGeneralSettings.entities[websiteId]);

export const getEcommerceGeneralSettings = (websiteId: number) => createSelector(getEcommerceGeneralSettingsState(websiteId),
  (state: IEcommerceGeneralSettingsEntityState) => {
    return state?.data ? state.data : [];
  }
);

export const getEcommerceCalcTaxes = (websiteId: number) => createSelector(getEcommerceGeneralSettingsState(websiteId),
    (state: IEcommerceGeneralSettingsEntityState) => {
        return state?.data ? state.data.find(item => item.id === "woocommerce_calc_taxes") : [];
    }
);

export const getEcommerceGeneralSettingsLoading = (websiteId: number) => createSelector(getEcommerceGeneralSettingsState(websiteId),
  (state: IEcommerceGeneralSettingsEntityState) => state && state.loading
);

export const getEcommerceGeneralSettingsLoaded = (websiteId: number) => createSelector(getEcommerceGeneralSettingsState(websiteId),
  (state: IEcommerceGeneralSettingsEntityState) => state && state.loaded
);
